import script from "./UserRegistrationFormMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegistrationFormMobile.vue?vue&type=script&setup=true&lang=js"

import "./UserRegistrationFormMobile.vue?vue&type=style&index=0&id=1afaf94c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afaf94c"]])

export default __exports__